import { SEARCH_BY_REG_REQUEST, SEARCH_BY_REG_REQUEST_SUCCESS, SEARCH_BY_REG_REQUEST_FAILURE } from '../constants/search_by_reg.constants';

const item = 'BRAND';
export const searchByRegRequest = searchText => ({
    type: SEARCH_BY_REG_REQUEST,
    searchText,
    item,
});

export const searchByRegRequestSuccess = payload => ({
    type: SEARCH_BY_REG_REQUEST_SUCCESS, payload, item,
});

export const searchByRegRequestFailure = error => ({
    type: SEARCH_BY_REG_REQUEST_FAILURE,
    error,
    item,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/search_by_reg.actions.js